import axios from 'axios'

const apiClient = axios.create({
//baseURL: `http://localhost:17823/`,
// baseURL: `https://fuldmagttestapi.gls.dk/`,
    baseURL: `https://fuldmagtapi.gls.dk/`,
  withCredentials: false,
  headers: { Accept: "application/json", "Content-Type": "application/json" }
});
export const SignerService = {
    async saveOnetimePremission(parcel){
	return await apiClient.post('/signer/saveonetimepremission',parcel);
  },
    async validateParcel(parcel){
        return await apiClient.post('/signer/validateparcel',parcel);
    },
    async getParcelInfo(parcel){
        return await apiClient.post('/signer/parcelinfo',parcel);
    },
    //Bruges ikke, men skal ikke slettes !!!
    async delete(orderId){
        return await apiClient.post('/signer/delete',{
            reference: orderId
        });
    }//
};
